import { Banner } from './Banner';

// TODO: in v9, move styled() from Banner.jsx to here
export var StyledBanner = Banner;